export default require('./Root').default
